import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import { resetFilteringStateAction } from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";

import type { CompanySearchResultsStateType } from "../types/common";

import * as ac from "./action-creators";

const INITIAL_COMPANY_SEARCH_RESULTS_STATE: CompanySearchResultsStateType = {
    otherFilters: {
        searchText: "",
    },
    isExcelExportActive: false,
    exportToCrmAs: undefined,
};

const companySearchResultsReducer = createReducer<
    CompanySearchResultsStateType,
    ActionType<typeof ac> | ReturnType<typeof resetFilteringStateAction>
>(INITIAL_COMPANY_SEARCH_RESULTS_STATE)
    /** Other filters */
    .handleAction(
        ac.updateOtherFiltersAction,
        (state, { payload }): CompanySearchResultsStateType => ({
            ...state,
            otherFilters: {
                ...state.otherFilters,
                ...payload,
            },
        }),
    )
    .handleAction(
        ac.otherFiltersClearedAction,
        (state): CompanySearchResultsStateType => ({
            ...state,
            otherFilters: INITIAL_COMPANY_SEARCH_RESULTS_STATE.otherFilters,
        }),
    )
    .handleAction(
        ac.setIsExcelExportActive,
        (state, { payload }): CompanySearchResultsStateType => ({
            ...state,
            isExcelExportActive: payload,
        }),
    )
    .handleAction(ac.initExportToCrmAs, (state, { payload }) => ({
        ...state,
        exportToCrmAs: payload,
    }))
    .handleAction(
        resetFilteringStateAction,
        (state): CompanySearchResultsStateType => ({
            ...state,
            otherFilters: INITIAL_COMPANY_SEARCH_RESULTS_STATE.otherFilters,
        }),
    );
export default companySearchResultsReducer;
